export default{
  hwxx: 'Cargo information',
  dxyd: 'Single container waybill',
  plzjxs: 'Increase the number of cases in batch',
  xzh: 'New row',
  sch: 'Delete row',
  xuhao: 'Serial number',
  xzhwmc: 'Select goods name',
  pinl: 'category',
  twbh: 'Iron hazard No',
  xianh: 'Case No',
  qsrxh: 'Please enter the case number',
  xianshu: 'Box genus',
  tielux: 'Railway box',
  zibeix: 'Self provided box',
  xianx: 'Box type',
  xianl: 'Box type',
  kongz: 'Empty weight',
  kong: 'empty',
  zhong: 'heavy',
  baozhuan: 'packing',
  cpchx: 'Go back to the box again',
  tielcdx: 'Railway open top box',
  tezx: 'Special case',
  cquch: 'Go back and forth',
  xiasch: 'Launching return',
  sfh: 'Seal No',
  zhognlqk: 'Weight (kg)',
  jiage: 'Price (yuan)',
  msg1: '*Description of goods name: if the corresponding name cannot be found in the goods name, fill in the name below and select the corresponding category. Please select self provided container (or container) for product name when sending self provided container and there is no goods in the container.',
  msg2: 'Fill in other product names (such as empty container, empty self-contained container, etc.), and the system will charge by heavy container.',
  ri: 'day',
  rysxq: 'Daily transportation demand',
  zyrq: 'Date of shipment',
  xzrq: 'Select date',
  xqtcfs: 'Demand presentation method',
  zjtcrxq: 'Direct daily demand',
  syjdxq: 'Use phase requirements',
  jdxqh: 'Stage demand No',
  qsrjdxqh: 'Please enter the stage demand number',
  ches: 'Number of cars',
  chec: 'Train number',
  liang: 'two',
  ldwl: 'Logistics at both ends',
  msg3: 'According to your needs, you can select to enter the logistics service information such as receiving, delivery and warehousing at the departure and arrival stations.',
  mdz: 'Door to station',
  smqh: 'Door to door pickup',
  zdm: 'Stand to the door',
  lxrxm: 'Contact name',
  dianh: 'Telephone',
  qhdz: 'Pick up address',
  qianmi: 'Kilometer',
  licheng: 'mileage',
  tyrqdjs: 'Number of pieces determined by the shipper',
  xuqsm: 'Requirements description',
  qhgsfy: 'Estimated pickup cost',
  smsh: 'Door to door delivery',
  shdz: 'Shipping address',
  tijiao: 'Submit',
  qink: 'empty',
  chax: 'query',
  yslx: 'Transport type',
  tuoyf: 'Shipper',
  souhf: 'Ship to',
  hwpm: 'Name of goods',
  slcs: 'Number of accepted vehicles',
  caoz: 'operation',
  xuanzhe: 'choice',
  xzjdxqh: 'Select stage demand No',
  shgsfy: 'Estimated cost of cargo delivery',
}

